import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-bank"
export default class extends Controller {
  static targets = [ "bank", "branchWrapper" ]
  connect() {

  }

  selectedBank(event) {
    const bankId = event.currentTarget.selectedOptions[0].value
    if (bankId.length > 0) {
      if (this.turboFrameElement)
        this.turboFrameElement.remove()
      
      this.turboFrameElement = document.createElement("turbo-frame")
      this.turboFrameElement.setAttribute("id", "input-field-branches")
      this.turboFrameElement.setAttribute("src", `/banks/${bankId}/branches/input_field`)

      // document.querySelector("#bank-wrapper")の次の要素にturbo-frameを追加
      document.querySelector("#bank-wrapper").insertAdjacentElement("afterend", this.turboFrameElement)
    } else {
      this.turboFrameElement.remove()
    }
  }
}
